import { COMPONENTS } from '../../../components/components.registry';
import { SearchBoxConfig } from '../../../models';

export const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  components: {
    searchBox: COMPONENTS.PURE.AutoCompleteSearchBox,
    placeholder: null,
    clearButtonContent: COMPONENTS.PURE.CrossIcon,
    icon: COMPONENTS.PURE.SearchIcon,
    extra: null
  },
  autoCompleteEnabled: true,
  autofocus: false,
  inputPreprocessor: null, // Capitalize first letter: SEARCHBOX_PREPROCESSORS.FirstLetterInUpperCase,
  inputsSelector: '.ebx-search-box__input',
  instantSearch: {
    debounceTimeInMs: 300,
    enabled: false
  },
  maxLength: 64,
  placeholder: {
    loopable: false,
    typingStepDurationInMs: 50,
    deletingStepDurationInMs: 30,
    delayDurationBetweenActionsInMs: 350
  }
};
